<template>
  <ul>
    <li v-for="err in errors" :key="err">{{ err }}</li>
  </ul>
</template>

<script>
export default {
  props: {
    errors: {
      type: Array,
      default() {
        return []
      },
    },
  },
}
</script>

<style lang="scss" scoped>
ul {
  padding-left: var(--spacing-small);
}

li {
  color: var(--color-warn, #ef5350);
}
</style>
